import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    constructor() {}

    stateCategories: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    stateCategoriesAccueil: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    stateFlatCategories: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    stateBrand: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    stateDepartment: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    extranetRestrictions: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    userStore: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    brandQuantityStore: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    supplierQuantityStore: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    setCategories(allCates: any) {
        this.stateCategories.next(allCates);
    }
    getCategories() {
        return this.stateCategories.asObservable();
    }

    setCategoriesAccueil(allCates: any) {
        this.stateCategoriesAccueil.next(allCates);
    }
    getCategoriesAccuei() {
        return this.stateCategoriesAccueil.asObservable();
    }

    setFlatCategories(allCates: any) {
        this.stateFlatCategories.next(allCates);
    }
    getFlatCategories() {
        return this.stateFlatCategories.asObservable();
    }

    setBrandStore(brands: any) {
        this.stateBrand.next(brands);
    }
    getBrandStore() {
        return this.stateBrand.asObservable();
    }

    setDepartmentStore(brands: any) {
        this.stateDepartment.next(brands);
    }
    getDepartmentStore() {
        return this.stateDepartment.asObservable();
    }

    setExtranetRestrictionsStore(items: any) {
        this.extranetRestrictions.next(items);
    }
    getExtranetRestrictionsStore() {
        return this.extranetRestrictions.asObservable();
    }

    setCurrentUserStore(items: any) {
        this.userStore.next(items);
    }
    getCurrentUserStore() {
        return this.userStore.asObservable();
    }

    /* Quantity of brand */

    setBrandQuantityStore(items: any) {
        this.brandQuantityStore.next(items);
    }
    getBrandQuantityStore() {
        return this.brandQuantityStore.asObservable();
    }

    setSupplierQuantityStore(items: any) {
        this.supplierQuantityStore.next(items);
    }
    getSupplierQuantityStore() {
        return this.supplierQuantityStore.asObservable();
    }
}
